import http from '../../http'

/**
 * Item 1.1.6 - Documentos / formatos del COPASST.
 * Dropdown para descargar el formato y subir el respectivo soporte.
 */
class CopasstDocAPI {
  /** Tipos de documento activos (opciones del dropdown). */
  async getTypes() {
    const response = await http(`copasst-doc-types`, 'GET')
    return response.CopasstActType.data || null
  }

  /** Guarda el soporte subido por la empresa para un tipo de documento. */
  async save(companies_id, copasst_act_type_id, file) {
    const response = await http(`copasst-doc/save`, 'POST', {
      companies_id,
      copasst_act_type_id,
      file,
    })
    return response || null
  }

  /** Historial de soportes subidos por la empresa. */
  async listForCompany(companyID) {
    const response = await http(`copasst-doc/company/${companyID}`, 'GET')
    return response.message || null
  }
}

export default new CopasstDocAPI();
